// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"vue":"173aa83d89ee7ef11dda","takeover":"507e37f73b27c7367586","mobilemenu":"39a5237e406bf16cde57"}[chunkId] + ".js";
};